// Collection descriptions and guide buttons are rendered by Liquid before first paint.
// Keep this file responsible only for the existing progressive pagination enhancement.

class MSCollectionPagination extends HTMLElement {
 connectedCallback() {
  this.link = this.querySelector('a');
  this.status = this.querySelector('[role="status"]');
  if (!this.link || !('IntersectionObserver' in window)) return;
  this.classList.add('is-automatic');
  this.link.addEventListener('click', event => { event.preventDefault(); this.loadNext(); });
  this.observer = new IntersectionObserver(entries => {
   if (entries.some(entry => entry.isIntersecting)) this.loadNext();
  }, { rootMargin: '450px 0px' });
  this.observer.observe(this);
 }
 disconnectedCallback() {
  this.observer?.disconnect();
  this.controller?.abort();
 }
 async loadNext() {
  if (this.loading || !this.link) return;
  this.loading = true;
  this.observer?.unobserve(this);
  this.classList.remove('has-error');
  this.status.textContent = this.dataset.loading;
  this.controller = new AbortController();
  try {
   const url = new URL(this.link.href);
   url.searchParams.set('section_id', this.dataset.section);
   const response = await fetch(url, { signal: this.controller.signal });
   if (!response.ok) throw new Error('Unable to load products');
   const html = new DOMParser().parseFromString(await response.text(), 'text/html');
   const incoming = html.querySelector('#product-grid');
   const grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
   if (!incoming || !grid || !this.isConnected) throw new Error('Missing product grid');
   incoming.querySelectorAll('.scroll-trigger').forEach(item => item.classList.add('scroll-trigger--cancel'));
   grid.append(...incoming.children);
   const next = html.querySelector('ms-collection-pagination a');
   this.status.textContent = '';
   if (next) {
    this.link.href = next.href;
    this.observer?.observe(this);
   } else {
    this.link.remove();
    this.link = null;
    this.status.textContent = this.dataset.complete;
   }
  } catch (error) {
   if (error.name !== 'AbortError') {
    this.classList.add('has-error');
    this.status.textContent = this.dataset.error;
   }
  } finally { this.loading = false; }
 }
}
if (!customElements.get('ms-collection-pagination')) customElements.define('ms-collection-pagination', MSCollectionPagination);
